<template>
    <div class="posts-wrapper">
      <div class="packages client memberships">                
        <div class="box-white-wrapper" v-if="packages.length > 0">
            <div class="editar">
                <router-link :to="`/admin/membership/detail/${packages[0].customer.memberof}`"><feather type="arrow-left"/>Regresar</router-link>
            </div>
            <vs-table :data="packages" pagination max-items="50">
              <template slot="thead">
                  <vs-th sort-key="customer.firstName">Ciente</vs-th>
                  <!-- <vs-th sort-key="tracking">Tracking</vs-th> -->
                  <vs-th sort-key="createdAt">Fecha</vs-th>
                  <vs-th sort-key="pounds" class="center">Cant Libras</vs-th>
                  <vs-th sort-key="totalCashBack" class="center">CashBox</vs-th>
                  <vs-th sort-key="id"></vs-th>
              </template>
              <template slot-scope="{data}">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
                    <vs-td :data="data[indextr].customer.firstName">{{ `${data[indextr].customer.firstName } ${data[indextr].customer.lastName}`}}</vs-td>
                    <vs-td :data="data[indextr].cantidadLibras">
                        {{data[indextr].createdAt | moment('DD/MM/YYYY')}}
                    </vs-td>
                    <vs-td :data="data[indextr].pounds" class="center"> {{ data[indextr].pounds }}</vs-td>
                    <vs-td :data="data[indextr].totalAmount" class="center"> ${{ data[indextr].totalAmount }}</vs-td>
                    <vs-td :data="data[indextr].id">
                        <div class="table-actions" v-if="data[indextr].pounds > 0">
                              <router-link :to="`/admin/cashback/member/detail/${periodId}/${data[indextr].customer.id}`"><feather type="eye"/></router-link>
                              <!-- <router-link :to="`/admin/cashback/member/detail/${periodId}/${data[indextr].customer.id}`"><feather type="credit-card"/></router-link> -->
                        </div>
                    </vs-td>
                  </vs-tr>
              </template>
          </vs-table>
        </div>
      </div>
    </div>
</template>
<script>
import { mapState, } from 'vuex'
import {helper} from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import MembershipService from "@/services/MembershipService"
export default {
    name: 'MembershipsView',
    mixins: [helper],
    data () {
        return {
            textarea: "",
            keyPackages: 0,
            noLimit: false,
            typeChangeSt: false,
            Roles: [],
            boxActive: null,
            keyword: "",
            filterObj: {
                dateFilter: null,
                status: null,
                filter: ""
            },
            packages: [],
            customer: "",
            periodId: ""
        }
    },
    created(){
        this.Roles = Role
        this.$Progress.start();
        if(this.userInfoData.role != this.Roles.Admin){
            this.$router.push('/')
        }
        this.periodId = this.$route.params.id
        this.getCashbackDetailAd(this.periodId)
        this.$Progress.finish()
    },
    computed: {
        ...mapState([
        'userInfoData'
        ]),
    },
    methods: {
        
        async getCashbackDetailAd (id) {
            let response = await MembershipService.getCashbackDetailAd({id: id})
            console.log(response)
            if((response.status / 100) == 2) {
                this.packages = response.data.data
            }
        },
        
    }
}
</script>
